import { Reducer } from 'redux';

import { ThreadExtendedActivityTopRepliesLoadAction } from '../../domains/threadExtendedActivityTopReplies/actions.types';

import { ThreadExtendedActivityTopRepliesLifecycle } from './types';

const initialState: ThreadExtendedActivityTopRepliesLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ThreadExtendedActivityTopRepliesLifecycle, ThreadExtendedActivityTopRepliesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.threadExtendedActivityTopReplies };
    case 'THREAD_EXTENDED_ACTIVITY_TOP_REPLIES.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
